import {
  GET_EVENT_INFO,
  GET_EVENT_INFO_SUCCESS,
  GET_EVENT_INFO_ERROR,
  GET_EVENTS_LIST,
  GET_EVENTS_LIST_SUCCESS,
  GET_EVENTS_LIST_ERROR,
  GET_EDITABLE_EVENT_ACTION,
  GET_EDITABLE_EVENT_ACTION_SUCCESS,
  GET_EDITABLE_EVENT_ACTION_ERROR,
  GET_MY_EVENTS,
  GET_MY_EVENTS_SUCCESS,
  GET_MY_EVENTS_ERROR,
  CHECK_USER_IS_OWNER_SUCCESS,
  CHECK_USER_IS_OWNER_ERROR,
  GET_EVENT_INFO_END_LIVE_UPDATES,
} from "store/actions/index";
import { removeChildrenProperty } from "utils";

const init: any = {
  isEditor: false,
  selectedEvent: {
    loading: false,
    error: false,
    numTimesRequested: 0,
    liveUpdates: false,
  },
  editing: {
    loading: false,
    error: false,
  },
  openEvents: {
    loading: false,
    error: false,
  },
  myEvents: {
    events: [],
    error: false,
    loading: false,
  },
};

const orbatReducer = (state: any = init, action: any): any => {
  switch (action.type) {
    case "@@router/LOCATION_CHANGE":
      return {
        ...state,
        state: {
          selectedEvent: {
            numTimesRequested: 0,
          },
        },
      };
    case GET_EVENT_INFO:
      return {
        ...state,
        selectedEvent: { ...state.selectedEvent, loading: true, error: false },
      };
    case GET_EVENT_INFO_SUCCESS:
      return {
        ...state,
        selectedEvent: {
          ...state.selectedEvent,
          ...action.payload,
          error: false,
          loading: false,
          numTimesRequested: state.selectedEvent.numTimesRequested + 1,
          liveUpdates: true,
        },
      };
    case GET_EVENT_INFO_ERROR:
      return {
        ...state,
        selectedEvent: {
          selectedEvent: { loading: false, error: true, numTimesRequested: 0 },
          error: true,
          loading: false,
          liveUpdates: false,
        },
      };
    case GET_EVENT_INFO_END_LIVE_UPDATES:
      return {
        ...state,
        selectedEvent: {
          ...state.selectedEvent,
          liveUpdates: false,
        },
      };
    case GET_EVENTS_LIST:
      return {
        ...state,
        openEvents: {
          loading: true,
          error: false,
        },
      };
    case GET_EVENTS_LIST_SUCCESS:
      return {
        ...state,
        openEvents: {
          loading: false,
          error: false,
          events: [...action.payload],
        },
      };
    case GET_EVENTS_LIST_ERROR:
      return {
        ...state,
        openEvents: {
          loading: false,
          error: action.payload,
          events: [],
        },
      };
    case GET_EDITABLE_EVENT_ACTION:
      return {
        ...state,
        editing: {
          loading: true,
          error: false,
          event: undefined,
        },
      };
    case GET_EDITABLE_EVENT_ACTION_SUCCESS:
      return {
        ...state,
        editing: {
          loading: false,
          error: false,
          event: { ...removeChildrenProperty(action.payload) },
        },
      };
    case GET_EDITABLE_EVENT_ACTION_ERROR:
      return {
        ...state,
        editing: {
          loading: false,
          error: true,
          event: undefined,
        },
      };
    case GET_MY_EVENTS:
      return {
        ...state,
        myEvents: {
          events: [],
          error: false,
          loading: true,
        },
      };
    case GET_MY_EVENTS_SUCCESS:
      return {
        ...state,
        myEvents: {
          events: action.payload,
          error: false,
          loading: false,
        },
      };
    case GET_MY_EVENTS_ERROR:
      return {
        ...state,
        myEvents: {
          events: [],
          error: true,
          loading: false,
        },
      };
    case CHECK_USER_IS_OWNER_SUCCESS:
      return {
        ...state,
        isEditor: true,
      };
    case CHECK_USER_IS_OWNER_ERROR:
      return {
        ...state,
        isEditor: false,
      };

    default:
      return state;
  }
};

export default orbatReducer;
